import { useState } from "react";
import StageSelector from "./StageSelector";

export default function ClassSelection({ classes, onSelect, onCancel, disabled,
                                          floorGates = {}, bossFloors = [2, 4, 6, 8, 10], finalFloor = 10, playerLevel = 1 }) {
  const [selected, setSelected] = useState(null);

  return (
    <div className="fade-up" data-testid="class-selection">
      <StageSelector
        floorGates={floorGates}
        bossFloors={bossFloors}
        finalFloor={finalFloor}
        playerLevel={playerLevel}
      />
      <div className="text-center mb-8">
        <p className="text-xs tracking-[0.4em] ash-text">CHOOSE YOUR VESSEL</p>
        <h2 className="font-heading text-4xl md:text-5xl mt-2 text-[#f0e6d2]">
          Which soul walks the <span className="gold-text italic">dark</span>?
        </h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {Object.entries(classes).map(([key, info]) => (
          <button
            key={key}
            data-testid={`class-card-${key}`}
            onClick={() => setSelected(key)}
            className={`panel p-6 text-left transition-all duration-300 hover:border-[#e25822] hover:shadow-[0_0_24px_rgba(226,88,34,0.3)] ${
              selected === key ? "border-[#d4af37] shadow-[0_0_24px_rgba(212,175,55,0.4)]" : ""
            }`}
          >
            <div className="text-[10px] tracking-[0.3em] ash-text">CLASS</div>
            <div className="font-heading text-3xl mt-1 gold-text">{info.name}</div>
            <p className="font-narrative text-base mt-3 text-[#a39d91] italic">{info.tagline}</p>
            <div className="mt-6 flex items-center gap-2 text-xs ash-text">
              <span>◆ 100 HP</span>
              <span>◆ 50 GOLD</span>
            </div>
          </button>
        ))}
      </div>
      <div className="mt-8 flex items-center justify-center gap-4">
        {onCancel && (
          <button onClick={onCancel} className="btn-glow" data-testid="class-cancel-btn">
            CANCEL
          </button>
        )}
        <button
          data-testid="start-run-btn"
          disabled={!selected || disabled}
          onClick={() => onSelect(selected)}
          className="btn-primary"
        >
          {disabled ? "SUMMONING..." : "▶  ENTER THE DUNGEON"}
        </button>
      </div>
    </div>
  );
}
